import styles from './FollowSuggestionRow.module.scss'
import { IUser } from '@/interfaces/IUser'
import NextImage from 'next/image'
import imageService from '@/modules/imageService/client'
import NextLink from 'next/link'
// import FastCircleLoader from '@/components/loaders/FastCircleLoader'
import {
  Avatar
  // Button as MuiButton
} from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
// import DoneIcon from '@mui/icons-material/Done'

interface IFollowSuggestionRowProps {
  user: IUser
  isSubscribing: boolean
  isSubscribed: boolean
  // eslint-disable-next-line no-unused-vars
  handleFollow: (user: IUser) => void
}

// function FollowSuggestionRow ({ user, isSubscribing, isSubscribed, handleFollow }: IFollowSuggestionRowProps) {
function FollowSuggestionRow ({ user }: IFollowSuggestionRowProps) {
  const link = `/${user.username}/profile`
  return (
    <div className={styles.wrapper}>
      <div className={styles.avatarWrapper}>
        <NextLink href={link}>
          {user.avatar &&
            <NextImage
              src={imageService.postImageURL('avatars', user.avatar)}
              alt='Avatar'
              width={35}
              height={35}
              className={styles.avatarImage}
              style={{ borderRadius: '50%', border: '1px solid rgba(0, 0, 0, 0.15)' }}
              // layout='responsive'
            />
          }
          {!user.avatar &&
            <Avatar sx={{ width: 35, height: 35, fontSize: 14 }} className={styles.avatarImage}>
              {user.username ? user.username[0].toUpperCase() : '?'}
            </Avatar>
          }
        </NextLink>
      </div>
      <div className={styles.content}>
        <NextLink href={link}>
          <h4 className={styles.contentUsername}>
            <span className={styles.hoverUsername}>{user.username}</span>
          </h4>
        </NextLink>
        <NextLink href={link}>
          <Tooltip title={user.bio || 'No bio provided'}>
            <p>{(user.bio || 'No bio provided').slice(0, 42).trim()}{(user.bio || '').length > 42 ? '...' : ''}</p>
          </Tooltip>
        </NextLink>
      </div>
      {/* <div className={styles.actions}>
        <MuiButton
          variant="outlined"
          size={'small'}
          color="primary"
          className={styles.button}
          fullWidth
          disabled={isSubscribing || isSubscribed}
          style={{ textTransform: 'none' }}
          startIcon={isSubscribed ? <DoneIcon /> : undefined}
          onClick={() => handleFollow(user)}
        >
          {!isSubscribing && !isSubscribed && 'Subscribe'}
          {isSubscribed && 'Subscribed'}
          {isSubscribing &&
            <div style={{ display: 'flex', alignItems: 'center', paddingTop: 3, paddingBottom: 3 }}>
              <FastCircleLoader size={15} />
            </div>
          }
        </MuiButton>
      </div> */}
    </div>
  )
}

export default FollowSuggestionRow
